import "core-js/modules/es.array.push.js";
import $ from 'jquery';
export default {
  data: function data() {
    return {
      isGray: false,
      isShow: false,
      arr: [{
        isTop: true
      }, {
        isTop: false
      }, {
        isTop: false
      }]
    };
  },
  created: function created() {},
  beforeDestroy: function beforeDestroy() {
    $('.container').off('click');
  },
  mounted: function mounted() {
    var _this = this;
    $('.container').on('click', function () {
      if (_this.isShow) {
        _this.isShow = !_this.isShow;
      }
    });
  },
  methods: {
    toSwitch: function toSwitch() {
      this.$toast('切换接口');
    },
    unbind: function unbind() {
      this.$router.push({
        path: '/vehicleUnbund'
      });
    },
    showPop: function showPop(item) {
      this.isShow = true;
      this.isGray = !item.isTop;
    },
    back: function back() {
      this.$router.back();
    }
  }
};